import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("span", {
    class: "symbol-counter",
    style: _normalizeStyle($options.my_style),
    nowrap: ""
  }, _toDisplayString($options.counter_text), 5 /* TEXT, STYLE */))
}